import React from "react";
import IuManagementPageBase from "../../SHARED/components/IuManagementPageBase";
import useInternalUserFeatures from "../../SHARED/hooks/useInternalUserFeatures";
import {
  IU_MANAGEMENT_PAGE_TITLE,
  IU_SYSTEM_MANAGEMENT_LINKS,
} from "../../SHARED/iuManagementPageConfig";

const SimpleUserSystemManagement = () => {
  const userFeatures = useInternalUserFeatures();

  return (
    <IuManagementPageBase
      title={IU_MANAGEMENT_PAGE_TITLE.system}
      links={IU_SYSTEM_MANAGEMENT_LINKS}
      filterByFeatures
      userFeatures={userFeatures}
    />
  );
};

export default SimpleUserSystemManagement;
